// extracted by mini-css-extract-plugin
export default {"link":"ProductCard_link__ibjtk","heading":"ProductCard_heading__IaxC6","image":"ProductCard_image__eXJH3","wrapper":"ProductCard_wrapper__TaZaw"};